export default "__VITE_ASSET__0fe7088b__"